window.addEventListener('DOMContentLoaded', function() {
    var isTypeurl = window.location.href;//判断是否是详情页
      if (isTypeurl.indexOf('products') != -1) {
    }
   setTimeout(productCus,1000);
   setTimeout(AddSize,1000);
   setTimeout(addImage,2000);
   setTimeout(Socks_color,10);
  
    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
     makeupTheDifferenceQty = getUrlParam('_amount');
  }
  
  if(makeupTheDifferenceQty !=null){
    $("input[name='quantity']").val(makeupTheDifferenceQty); 
  }
})

function AddSize(){
    var obj=$('[label_name="properties[Gender]"]').parents('.bigtur_simple');
    var modal = '<a data-toggle="modal" data-target="#size_chart" class="size-chart-open-popup no_variant"><span>Size guide</span></a>';
    if(typeof(obj.html())=="undefined" || obj == null ) {
        setTimeout(AddSize,1000);

    } else {
       obj.each(function(){
            $(this).find(".bigtur_div_extend").append(modal);
        });

    }
}

function getUrlParam(name) {
     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return unescape(r[2]); return null; //返回参数值
}

function productCus() {
    var _upload = $("input[name='properties[Upload Logo]'],input[name='properties[Team Logo]']");
    if (_upload.attr("data-price") != null) {
        _upload.attr("accept", "image/png, image/jpeg,image/jpg");
        if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
            $("span[class='bigtur_title']").each(function () {
                var htm = $(this).html();
                var title = $(this).text();
                 if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1) {
                    htm = "<font size=\"-2\">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>";
                }
            });
        }
    }
    else {
        setTimeout(productCus, 100);
    }
}

function addImage(){
      var obj=$("input[name='ymq[Picture style]']");
     var img = '';
     obj.each(function(){
       if($(this).val() == 'original picture'){
         img = 'https://cdn.shopify.com/s/files/1/0642/1138/6619/files/original__picture.jpg?v=1681117563'
       }else{
          img = 'https://cdn.shopify.com/s/files/1/0642/1138/6619/files/Hand_Drawn.jpg?v=1681117562'
       }
       $(this).next().prepend('<img src="'+img+'">');
       })

}


function Socks_color(){
  goods = $('h1.product-title span').text()
  if(goods.indexOf('Socks')>-1){
    // 颜色
   $('.swatch-element.color.available').each(function(){
     data_value = $(this).find('input').attr('id')
    stickyValue = $('[data-value='+data_value+']').eq(0).attr('data-value-sticky');
    data_imge = $('select[name="id"] option[value="' + stickyValue + '"]').attr('data-imge');
     color = $(this).find('.bgImg').text()
    html = '<img src="'+data_imge+'">'+color;
     console.log(html)
     console.log($(this).find('.bgImg'))
     $(this).find('.bgImg').empty().append(html)
     
      })

    // 尺码
    $('.header.has-size-chart.a-').append('<a data-toggle="modal" data-target="#size_chart" class="size-chart-open-popup no_variant" style="margin-left: 8px;"><span>Size guide</span></a>')
  }
}




